import { Inject, Injectable } from '@angular/core'
import {
    State,
    StateModel,
    StreamStore,
} from '@undock/core/states'
import {
    DestroyEvent,
    EmitOnDestroy,
    StatefulSubject,
    ValueSubject,
} from '@typeheim/fire-rx'
import { Api } from '@undock/api'
import { CurrentUser } from '@undock/session'


@Injectable({
    providedIn: 'root',
})
export class BriefsManager extends StateModel<BriefsStore> {

    protected readonly store = new BriefsStore()

    @EmitOnDestroy()
    protected readonly destroyEvent = new DestroyEvent()

    public constructor(
        protected api: Api,
        protected currentUser: CurrentUser,
    ) { super() }

    public async getBriefSummaryForDate(date: Date) {
        if (date) {
            this.store.isLoading$.next(true)

            let cache = await this.store.briefsCache

            if (cache[date.toISOString()]) {
                this.store.currentBrief$.next(cache[date.toISOString()])
            } else {
                let loadedBriefs = await this.api.nlp.briefs.getBriefsSummary(date.toISOString())

                this.store.currentBrief$.next(loadedBriefs)
                cache[date.toISOString()] = loadedBriefs
            }

            this.store.isLoading$.next(false)
        }
    }
}

export class BriefsStore extends StreamStore {
    
    public readonly isLoading$ = new ValueSubject<boolean>(false)

    public readonly currentBrief$ = new StatefulSubject<string[]>()

    public readonly briefsCache = new ValueSubject<{[key: string]: string[]}>({})
}

export type BriefsStoreState = State<BriefsStore>
